export { default } from './standard_gateway';



// WEBPACK FOOTER //
// ./src/scripts/adapters/gateways/lib/standard_gateway/index.js